<template>
	<div class="page-deliver-todo">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">珠海倉庫</div>
			<div class="breadcrumb-item">大包号列表</div>
		</div>
		<div class="card-block">
			<Form inline class="pg-form-inline">
				<!--			<FormItem>
					<Select style="width: 100%;" size="small" placeholder="提貨櫃點" v-model="form.arrive" clearable>
						<Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
										:key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
						</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Select style="width: 100%;" size="small" placeholder="業務類型" v-model="form.goods_type">
						<Option :value="0">無</Option>
						<Option :value="item.id" v-for="(item, index) in packageType"
										:key="item.id">
							{{ item.describe }}
						</Option>
					</Select>
				</FormItem>
			
				<FormItem>
					<Select style="width: 100%;" size="small" placeholder="第三方列表" v-model="form.order_parent" clearable>
						<Option :value="item.id" v-for="(item, index) in samcityType"
										:key="item.id">
							{{ item.name }}
						</Option>
					</Select>
				</FormItem>
			
				<FormItem>
					<Select style="width: 100%;" size="small" placeholder="收件方式" v-model="form.arrive_type" clearable>
						<Option value="1">門店</Option>
						<Option value="2">智能櫃</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Select style="width: 100%;" size="small" placeholder="操作人" v-model="form.admin_id" clearable>
						<Option :value="item.user_id" v-for="(item, index) in pickAdmin"
										:key="item.user_id">{{ item.username }} ({{ item.realname }})
						</Option>
					</Select>
				</FormItem>
				-->
				<FormItem>
					<DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
					            placeholder="珠海入庫-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss"
					            :editable="false" style='width: 100%;'></DatePicker>
				</FormItem>
				<FormItem>-</FormItem>
				<FormItem>
					<DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
					            placeholder="珠海入庫-結束日期" v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss"
					            :editable="false" style='width: 100%;'></DatePicker>
				</FormItem>
			</Form>
			<Form inline class="pg-form-inline form-input-wrap">
				<FormItem>
					<label class="input-label">袋号</label>
					<Input size="small" v-model="form.sack_number" @keyup.enter.native="handleSearch()" clearable></Input>
				</FormItem>
				<!--				<FormItem>
									<label class="input-label">客戶名稱</label>
									<Input size="small" clearable v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"
												 clearable>
									</Input>
								</FormItem>
								<FormItem>
									<label class="input-label">客戶電話</label>
									<Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()" clearable></Input>
								</FormItem>-->
				<FormItem>
					<div class="pg-btn-wrap">
						<div class="pg-btn style1" @click="handleSearch">搜索</div>
						<a target="_blank" class="pg-btn style2" @click="handleExport"
						   style="margin-left: 15px;">導出excel</a>
					</div>
				</FormItem>
			</Form>
		</div>
		
		<div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>
			
			<Table size="small"
			       border
			       no-data-text="暫無數據"
			       :columns="table.column"
			       @on-selection-change="selectionChange"
			       :data="table.data">
				<template slot-scope="{ row, index }" slot="action">
					<div class="pg-btn-wrap">
						<div v-if="martStore(row)" class="pg-btn style1" @click="handleEdit(row)">打印袋号</div>
					</div>
				</template>
				<template slot-scope="{ row, index }" slot="store">
					<div class="pg-btn-wrap">
						<span>{{ filterStore(row) }}</span>
					</div>
				</template>
			
			</Table>
			
			<div class="pg-pagger">
				<Row>
					<Col span="11" class="pagger-left">
						<div class="pagger-total">總共{{ totalCount }}條記錄</div>
						<br>
						<div class="pagger-total">總重量為{{ totalWeight }}公斤</div>
					</Col>
					<Col span="13" class="pagger-right">
						<!-- v-if="totalCount > curPageSize" -->
						<div>
							<div class="pagger-sizer">
								<span>每頁</span>
								<Select v-model="curPageSize" size="small" placeholder="數量"
								        @on-change="handlePageSizeChange">
									<Option :value="10">10</Option>
									<Option :value="20">20</Option>
									<Option :value="30">30</Option>
									<Option :value="40">40</Option>
									<Option :value="50">50</Option>
								</Select>
							</div>
							
							<div class="pagger-elevator">
								<span>跳轉</span>
								<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
								       @on-enter="handlePageEnter"/>
							</div>
							
							<Page size="small"
							      :current="pageIndex"
							      :page-size="curPageSize"
							      :total="totalCount"
							      @on-change="handlePageChange">
							</Page>
						</div>
					</Col>
				</Row>
			</div>
		
		</div>
		<PrintInCode3 ref="print_box3"/>
	</div>
</template>

<script>
import axios from 'axios';
import PrintInCode3 from "../../../components/PrintInCode3";
import PrintInCode from "../../../components/PrintInCode";

export default {
	components: {
		PrintInCode3
	},
	data() {
		return {
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 1, //总条数
			totalWeight: 0, //總重量
			pageInput: '',  //输入的页码
			pickAddress: [],    //提貨櫃點
			packageType: [],    //包裹類型
			samcityType: [],    //同城
			pickAdmin: [],
			form: {
				arrive: '',    //提货柜点
				arrive_type: '',    //收件方式，1门店，2智能柜
				goods_type: 0, //包裹类型
				start_time: '',
				end_time: '',
				recipient_contacts: '', //客户名称
				phone: '',  //客户手机号
				odd_numbers: '',    //快递单号
				sack_number: '',    //袋号
				admin_id: '',
				order_parent: '',
			},
			isSubmiting: false,
			// isLoading: true,
			exportLink: '', //导出地址
			table: {
				column: [
					{
					    type: 'selection',
					    minWidth: 60,
					    align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 150
					},
					{
						title: '门店',
						slot: 'store',
						align: 'center',
						minWidth: 150
					},
					{
						title: '袋号',
						key: 'bag_number',
						align: 'center',
						sortable: true,
						minWidth: 130
					}, {
						title: '数量',
						key: 'order_number',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '状态',
						key: 'out_name',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '时间',
						key: 'time',
						align: 'center',
						sortable: true,
						minWidth: 160
					},
				
				
				],
				data: []
			},
			selectedData: []
		};
	},
	created() {
		this.getList();
	},
	activated() {
		// this.getPickAddress();
		// this.getPackageType();
		// this.getSamcityList();
		this.getList();
		// this.getPickAdmin();
	},
	mounted() {
		// this.getPickAddress();
		// this.getPackageType();
		// this.getSamcityList();
		// this.getPickAdmin();
	},
	methods: {
		selectionChange(row) {
			console.log(row)
			this.selectedData = row.map(item => item.bag_number)
		},
		martStore(row) {
			const store = row?.goods?.storename?.ReceivingName;
			console.log(store)
			return store ? true : false;
		},
		filterStore(row) {
			const store = row?.goods?.storename?.ReceivingName;
			return store ? store : '---'
		},
		getSamcityList() {
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.samcityType = res.data.data;
				}
			});
		},
		//提貨櫃點
		getPickAddress() {
			this.$Rq.requestAuth({
				url: this.$Api.pickAddress,
				method: 'get',
				data: {
					company_id: 0,
					type: 1,
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAddress = res.data.data.filter(it=>it.company_id != 15);;
				}
			});
		},
		//操作人
		getPickAdmin() {
			this.$Rq.requestAuth({
				url: this.$Api.pickAdmin,
				method: 'post',
				data: {
					parent_id: 1,
				}
			}).then((res) => {
				if (res.code == 0) {
					this.pickAdmin = res.data.data;
				}
			});
		},
		//包裹類型
		getPackageType() {
			this.$Rq.requestAuth({
				url: this.$Api.packageType,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.packageType = res.data.data;
				}
			});
		},
		
		formatDate(datetime) {
			if (!datetime) return '';
			
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		getList() {
			this.totalCount = 0;
			this.totalWeight = 0;
			this.table.data = [];
			this.selectedData = [];
			let form = this.form;
			this.isSubmiting = true;
			// this.isLoading = true;
			this.$Rq.requestAuth({
				url: this.$Api.bagNumberTable,
				method: 'get',
				data: {
					bag_number: form.sack_number,
					limit: this.curPageSize,
					page: this.pageIndex,
				}
			}).then((res) => {
				// this.isLoading = false;
				this.isSubmiting = false;
				const resData = res.data;
				this.totalCount = res.total;
				this.table.data = resData;
			}).catch((err) => {
				// this.isLoading = false;
				this.isSubmiting = false;
			});
		},
		
		handleSearch() {
			this.pageIndex = 1;
			this.getList();
		},
		
		handleEdit(row) {
			const store = row?.goods?.storename?.ReceivingName || ''
			const data = {
				count: row.order_number,
				sack_number: row.bag_number,
				store,
			}
			this.$refs.print_box3.printCode(data, (res) => {
				const msg = res == 'yes' ? '打印成功' : '打印失败'
				this.$message.success(msg)
			})
			// let tableData = this.table.data;
			// this.$router.push({path: '/deliverTodoEdit?id=' + tableData[index].id});
		},
		handleDelete(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定刪除嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					
					this.$Rq.requestAuth({
						url: this.$Api.deliverDelete + '/' + tableData[index].id,
						method: 'delete'
					}).then((res) => {
						this.isSubmiting = false;
						
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							
							if (tableData.length <= 1 && this.pageIndex > 1) {
								this.pageIndex -= 1;
							}
							
							this.getList();
							
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
					
				}
			});
		},
		
		handleExport() {
			
			
			const selectData = this.selectedData;
			if (!selectData.length) {
				if (!this.form.start_time || !this.form.end_time) {
					return this.$message.error('請輸入查詢條件')
				}
			}
			
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			let params = {
				// 'Authorization': token,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
				// sack_number: selectData
			};
			
			let formatParams = this.$Utils.formateObjToParamStr(params);
			console.log(formatParams,selectData);
			for (let i = 0; i < selectData.length; i++) {
				formatParams += `&sack_number[${i}]=` + selectData[i];
			}
			console.log(formatParams)
			
			/*this.$Rq.requestAuth({
				url: this.$Api.bagNumberExport,
				method: 'get',
				data: params
			}).then(res => {
				console.log(res)
			})*/
			window.open(`${this.$Api.bagNumberExport}?${formatParams}`, '_blank');
			setTimeout(() => this.getList(), 2000);
		},
		
		//pager
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "BagNumberList.scss";
</style>
